import { render } from "./BackgroundLogin.vue?vue&type=template&id=3d5547b0&scoped=true"
const script = {}

import "./BackgroundLogin.vue?vue&type=style&index=0&id=3d5547b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5547b0"]])

export default __exports__